let _initProto, _initClass, _init_variant, _init_extra_variant, _init_orientation, _init_extra_orientation, _init_value, _init_extra_value, _init_rangeMin, _init_extra_rangeMin, _init_rangeMax, _init_extra_rangeMax, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_step, _init_extra_step, _init_minDistance, _init_extra_minDistance, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_showValue, _init_extra_showValue, _init_valueTitle, _init_extra_valueTitle, _init_changeEvent, _init_extra_changeEvent, _init_inputTarget, _init_extra_inputTarget, _init_maxInputTarget, _init_extra_maxInputTarget, _init_rootTarget, _init_extra_rootTarget, _init_headerTarget, _init_extra_headerTarget, _init_labelTarget, _init_extra_labelTarget, _init_rangeTrack, _init_extra_rangeTrack, _init_valueTarget, _init_extra_valueTarget, _init_singleThumb, _init_extra_singleThumb, _init_rangeMinThumb, _init_extra_rangeMinThumb, _init_rangeMaxThumb, _init_extra_rangeMaxThumb;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { createNumericRange, valueFromSliderKey } from "../shared/numeric-range";
let _RuiSlider;
class RuiSlider extends RadiantElement {
  static {
    ({
      e: [_init_variant, _init_extra_variant, _init_orientation, _init_extra_orientation, _init_value, _init_extra_value, _init_rangeMin, _init_extra_rangeMin, _init_rangeMax, _init_extra_rangeMax, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_step, _init_extra_step, _init_minDistance, _init_extra_minDistance, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_showValue, _init_extra_showValue, _init_valueTitle, _init_extra_valueTitle, _init_changeEvent, _init_extra_changeEvent, _init_inputTarget, _init_extra_inputTarget, _init_maxInputTarget, _init_extra_maxInputTarget, _init_rootTarget, _init_extra_rootTarget, _init_headerTarget, _init_extra_headerTarget, _init_labelTarget, _init_extra_labelTarget, _init_rangeTrack, _init_extra_rangeTrack, _init_valueTarget, _init_extra_valueTarget, _init_singleThumb, _init_extra_singleThumb, _init_rangeMinThumb, _init_extra_rangeMinThumb, _init_rangeMaxThumb, _init_extra_rangeMaxThumb, _initProto],
      c: [_RuiSlider, _initClass]
    } = _applyDecs(this, [customElement("rui-slider")], [[prop({
      type: String,
      defaultValue: "single"
    }), 0, "variant"], [prop({
      type: String,
      defaultValue: "horizontal"
    }), 0, "orientation"], [prop({
      type: Number,
      reflect: true,
      defaultValue: 50
    }), 0, "value"], [prop({
      type: Number,
      reflect: true,
      attribute: "range-min",
      defaultValue: 25
    }), 0, "rangeMin"], [prop({
      type: Number,
      reflect: true,
      attribute: "range-max",
      defaultValue: 75
    }), 0, "rangeMax"], [prop({
      type: Number,
      defaultValue: 0
    }), 0, "min"], [prop({
      type: Number,
      defaultValue: 100
    }), 0, "max"], [prop({
      type: Number,
      defaultValue: 1
    }), 0, "step"], [prop({
      type: Number,
      defaultValue: 0
    }), 0, "minDistance"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: Boolean,
      attribute: "read-only",
      reflect: true,
      defaultValue: false
    }), 0, "readOnly"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "name"], [prop({
      type: Boolean,
      attribute: "show-value",
      defaultValue: false
    }), 0, "showValue"], [prop({
      type: Boolean,
      attribute: "value-title",
      defaultValue: false
    }), 0, "valueTitle"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [query({
      ref: "input"
    }), 0, "inputTarget"], [query({
      ref: "maxInput"
    }), 0, "maxInputTarget"], [query({
      ref: "root"
    }), 0, "rootTarget"], [query({
      ref: "header"
    }), 0, "headerTarget"], [query({
      ref: "label"
    }), 0, "labelTarget"], [query({
      ref: "rangeTrack"
    }), 0, "rangeTrack"], [query({
      ref: "value"
    }), 0, "valueTarget"], [query({
      ref: "singleThumb"
    }), 0, "singleThumb"], [query({
      ref: "rangeMinThumb"
    }), 0, "rangeMinThumb"], [query({
      ref: "rangeMaxThumb"
    }), 0, "rangeMaxThumb"], [onUpdated(["value", "rangeMin", "rangeMax", "min", "max", "step", "minDistance", "variant", "orientation", "disabled", "readOnly", "label", "name", "showValue", "valueTitle"]), 2, "onPropsUpdated"], [onEvent({
      ref: "rangeTrack",
      type: "pointerdown"
    }), 2, "onPointerDown"], [onEvent({
      document: true,
      type: "pointermove"
    }), 2, "onPointerMove"], [onEvent({
      document: true,
      type: "pointerup"
    }), 2, "onPointerUp"], [onEvent({
      document: true,
      type: "pointercancel"
    }), 2, "onPointerCancel"], [onEvent({
      selector: "[data-thumb]",
      type: "keydown"
    }), 2, "onThumbKeydown"]], 0, void 0, RadiantElement));
  }
  variant = (_initProto(this), _init_variant(this));
  orientation = (_init_extra_variant(this), _init_orientation(this));
  value = (_init_extra_orientation(this), _init_value(this));
  rangeMin = (_init_extra_value(this), _init_rangeMin(this));
  rangeMax = (_init_extra_rangeMin(this), _init_rangeMax(this));
  min = (_init_extra_rangeMax(this), _init_min(this));
  max = (_init_extra_min(this), _init_max(this));
  step = (_init_extra_max(this), _init_step(this));
  minDistance = (_init_extra_step(this), _init_minDistance(this));
  disabled = (_init_extra_minDistance(this), _init_disabled(this));
  readOnly = (_init_extra_disabled(this), _init_readOnly(this));
  label = (_init_extra_readOnly(this), _init_label(this));
  name = (_init_extra_label(this), _init_name(this));
  showValue = (_init_extra_name(this), _init_showValue(this));
  valueTitle = (_init_extra_showValue(this), _init_valueTitle(this));
  changeEvent = (_init_extra_valueTitle(this), _init_changeEvent(this));
  inputTarget = (_init_extra_changeEvent(this), _init_inputTarget(this));
  maxInputTarget = (_init_extra_inputTarget(this), _init_maxInputTarget(this));
  rootTarget = (_init_extra_maxInputTarget(this), _init_rootTarget(this));
  headerTarget = (_init_extra_rootTarget(this), _init_headerTarget(this));
  labelTarget = (_init_extra_headerTarget(this), _init_labelTarget(this));
  rangeTrack = (_init_extra_labelTarget(this), _init_rangeTrack(this));
  valueTarget = (_init_extra_rangeTrack(this), _init_valueTarget(this));
  singleThumb = (_init_extra_valueTarget(this), _init_singleThumb(this));
  rangeMinThumb = (_init_extra_singleThumb(this), _init_rangeMinThumb(this));
  rangeMaxThumb = (_init_extra_rangeMinThumb(this), _init_rangeMaxThumb(this));
  activeThumb = (_init_extra_rangeMaxThumb(this), null);
  activePointerId = null;
  pending = null;
  lastEmitted = "";
  onConnected() {
    this.syncChrome();
    this.syncValues(this.committedValues());
  }
  onPropsUpdated() {
    if (this.activeThumb) {
      return;
    }
    this.syncChrome();
    this.syncValues(this.committedValues());
  }
  get isRange() {
    return this.variant === "range";
  }
  get isVertical() {
    return this.orientation === "vertical";
  }
  get numericRange() {
    return createNumericRange(this.min, this.max, this.step);
  }
  get defaultValueTarget() {
    return this.querySelector("[data-default-value]");
  }
  thumbFor(id) {
    if (id === "value") {
      return this.singleThumb;
    }
    return id === "min" ? this.rangeMinThumb : this.rangeMaxThumb;
  }
  parseThumb(value) {
    if (this.isRange) {
      return value === "min" || value === "max" ? value : null;
    }
    return value === "value" ? value : null;
  }
  constrainPair(low, high, active) {
    const range = this.numericRange;
    let nextLow = range.clamp(low);
    let nextHigh = range.clamp(high);
    if (nextLow > nextHigh) {
      [nextLow, nextHigh] = [nextHigh, nextLow];
    }
    const minDistance = Math.max(0, this.minDistance);
    if (nextHigh - nextLow < minDistance) {
      if (active === "min") {
        nextLow = range.clamp(nextHigh - minDistance);
      } else {
        nextHigh = range.clamp(nextLow + minDistance);
      }
    }
    return [nextLow, nextHigh];
  }
  committedValues() {
    if (this.isRange) {
      return this.constrainPair(this.rangeMin, this.rangeMax);
    }
    return [this.numericRange.clamp(this.value)];
  }
  liveValues() {
    return this.pending ?? this.committedValues();
  }
  changeDetail(values) {
    return values.length === 2 ? {
      values: [values[0], values[1]]
    } : {
      value: values[0]
    };
  }
  emitIfChanged(values) {
    const key = values.join(",");
    if (key === this.lastEmitted) {
      return;
    }
    this.lastEmitted = key;
    this.changeEvent.emit(this.changeDetail(values));
  }
  reflectValues(values) {
    if (values.length === 2) {
      if (this.rangeMin !== values[0]) {
        this.rangeMin = values[0];
      }
      if (this.rangeMax !== values[1]) {
        this.rangeMax = values[1];
      }
      return;
    }
    if (this.value !== values[0]) {
      this.value = values[0];
    }
  }
  syncValues(values) {
    this.paint(values);
    this.reflectValues(values);
  }
  syncChrome() {
    const disabled = this.disabled;
    const range = this.isRange;
    const tabindex = disabled ? -1 : 0;
    const orientation = this.isVertical ? "vertical" : "horizontal";
    const hasDefaultValue = Boolean(this.defaultValueTarget);
    const hasVisibleReadout = Boolean(this.valueTarget) && (!hasDefaultValue || this.showValue);
    const rangeBounds = this.numericRange;
    this.rootTarget?.classList.toggle("rui-slider--single", !range);
    this.rootTarget?.classList.toggle("rui-slider--range", range);
    this.rootTarget?.classList.toggle("rui-slider--vertical", this.isVertical);
    this.labelTarget?.toggleAttribute("hidden", !this.label);
    if (this.labelTarget) {
      this.labelTarget.textContent = this.label;
    }
    this.defaultValueTarget?.toggleAttribute("hidden", !this.showValue);
    this.headerTarget?.toggleAttribute("hidden", !this.label && !hasVisibleReadout);
    const thumbs = [["value", this.label || "Value", !range], ["min", this.label ? `${this.label} minimum` : "Minimum value", range], ["max", this.label ? `${this.label} maximum` : "Maximum value", range]];
    for (const [id, ariaLabel, visible] of thumbs) {
      const thumb = this.thumbFor(id);
      if (!thumb) {
        continue;
      }
      thumb.toggleAttribute("hidden", !visible);
      thumb.toggleAttribute("disabled", disabled || !visible);
      thumb.setAttribute("tabindex", String(visible ? tabindex : -1));
      thumb.setAttribute("aria-label", ariaLabel);
      thumb.setAttribute("aria-orientation", orientation);
      thumb.setAttribute("aria-valuemin", String(rangeBounds.lowerBound));
      thumb.setAttribute("aria-valuemax", String(rangeBounds.upperBound));
      thumb.setAttribute("aria-readonly", String(this.readOnly));
    }
  }
  paint(values) {
    const range = this.numericRange;
    const start = values[0];
    const end = values.length === 2 ? values[1] : values[0];
    const startPercent = `${range.ratioFor(start) * 100}%`;
    const endPercent = `${range.ratioFor(end) * 100}%`;
    const fillSize = `${(range.ratioFor(end) - range.ratioFor(start)) * 100}%`;
    const track = this.rangeTrack;
    track?.style.setProperty("--rui-slider-fill-start", values.length === 2 ? startPercent : "0%");
    track?.style.setProperty("--rui-slider-fill-size", values.length === 2 ? fillSize : endPercent);
    track?.style.setProperty("--rui-slider-value", startPercent);
    track?.style.setProperty("--rui-slider-min", startPercent);
    track?.style.setProperty("--rui-slider-max", endPercent);
    if (this.singleThumb) {
      this.singleThumb.setAttribute("aria-valuenow", String(start));
    }
    if (this.rangeMinThumb) {
      this.rangeMinThumb.setAttribute("aria-valuenow", String(start));
      this.rangeMinThumb.setAttribute("aria-valuemax", String(end));
    }
    if (this.rangeMaxThumb) {
      this.rangeMaxThumb.setAttribute("aria-valuemin", String(start));
      this.rangeMaxThumb.setAttribute("aria-valuenow", String(end));
    }
    if (this.valueTarget) {
      this.valueTarget.textContent = values.length === 2 ? `${start} \u2013 ${end}` : String(start);
    }
    this.syncInputs(values);
    this.syncValueTitle(values);
  }
  syncInputs(values) {
    if (this.inputTarget) {
      this.inputTarget.disabled = this.disabled;
      this.inputTarget.readOnly = this.readOnly;
      this.inputTarget.value = String(values[0]);
      if (this.name) {
        this.inputTarget.name = this.name;
      } else {
        this.inputTarget.removeAttribute("name");
      }
    }
    if (!this.maxInputTarget) {
      return;
    }
    this.maxInputTarget.disabled = this.disabled;
    this.maxInputTarget.readOnly = this.readOnly;
    if (values.length === 2) {
      this.maxInputTarget.value = String(values[1]);
      if (this.name) {
        this.maxInputTarget.name = `${this.name}-max`;
      } else {
        this.maxInputTarget.removeAttribute("name");
      }
      return;
    }
    this.maxInputTarget.value = "";
    this.maxInputTarget.removeAttribute("name");
  }
  syncValueTitle(values) {
    const thumbs = [this.singleThumb, this.rangeMinThumb, this.rangeMaxThumb];
    if (!this.valueTitle) {
      this.inputTarget?.removeAttribute("title");
      this.maxInputTarget?.removeAttribute("title");
      this.rangeTrack?.removeAttribute("title");
      for (const thumb of thumbs) {
        thumb?.removeAttribute("title");
      }
      return;
    }
    if (values.length === 1) {
      const title = String(values[0]);
      this.inputTarget?.setAttribute("title", title);
      this.maxInputTarget?.removeAttribute("title");
      this.rangeTrack?.removeAttribute("title");
      this.singleThumb?.setAttribute("title", title);
      this.rangeMinThumb?.removeAttribute("title");
      this.rangeMaxThumb?.removeAttribute("title");
      return;
    }
    const [low, high] = values;
    this.inputTarget?.setAttribute("title", String(low));
    this.maxInputTarget?.setAttribute("title", String(high));
    this.rangeTrack?.setAttribute("title", `${low} \u2013 ${high}`);
    this.singleThumb?.removeAttribute("title");
    this.rangeMinThumb?.setAttribute("title", String(low));
    this.rangeMaxThumb?.setAttribute("title", String(high));
  }
  valueFromPointer(event2) {
    const track = this.rangeTrack;
    if (!track) {
      return this.numericRange.lowerBound;
    }
    const rect = track.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) {
      return this.numericRange.lowerBound;
    }
    const ratio = this.isVertical ? 1 - (event2.clientY - rect.top) / rect.height : (event2.clientX - rect.left) / rect.width;
    return this.numericRange.valueFromRatio(ratio);
  }
  nearestThumb(next) {
    if (!this.isRange) {
      return "value";
    }
    const [low, high] = this.liveValues();
    return Math.abs(next - low) <= Math.abs(next - high) ? "min" : "max";
  }
  moveThumb(thumb, next) {
    this.activeThumb = thumb;
    if (this.isRange) {
      const current = this.pending ?? this.committedValues();
      this.pending = this.constrainPair(thumb === "min" ? next : current[0], thumb === "max" ? next : current[1], thumb);
    } else {
      this.pending = [this.numericRange.clamp(next)];
    }
    const values = this.pending;
    this.paint(values);
    this.emitIfChanged(values);
    return values;
  }
  commit() {
    const values = this.liveValues();
    this.pending = null;
    this.activeThumb = null;
    this.activePointerId = null;
    this.syncValues(values);
  }
  revert() {
    this.pending = null;
    this.activeThumb = null;
    this.activePointerId = null;
    this.lastEmitted = this.committedValues().join(",");
    this.paint(this.committedValues());
  }
  releasePointer(event2) {
    const track = this.rangeTrack;
    if (track?.hasPointerCapture(event2.pointerId)) {
      track.releasePointerCapture(event2.pointerId);
    }
  }
  onPointerDown(event2) {
    if (event2.button !== 0 || this.disabled || this.readOnly) {
      return;
    }
    const thumbElement = event2.target.closest("[data-thumb]");
    const fromThumb = this.parseThumb(thumbElement?.getAttribute("data-thumb") ?? null);
    const next = this.valueFromPointer(event2);
    const thumb = fromThumb ?? this.nearestThumb(next);
    this.pending = this.committedValues();
    this.lastEmitted = this.pending.join(",");
    this.activeThumb = thumb;
    this.activePointerId = event2.pointerId;
    this.rangeTrack?.setPointerCapture(event2.pointerId);
    this.thumbFor(thumb)?.focus();
    if (!fromThumb) {
      this.moveThumb(thumb, next);
    }
    event2.preventDefault();
  }
  onPointerMove(event2) {
    if (!this.activeThumb || event2.pointerId !== this.activePointerId) {
      return;
    }
    this.moveThumb(this.activeThumb, this.valueFromPointer(event2));
  }
  onPointerUp(event2) {
    if (!this.activeThumb || event2.pointerId !== this.activePointerId) {
      return;
    }
    this.releasePointer(event2);
    this.commit();
  }
  onPointerCancel(event2) {
    if (!this.activeThumb || event2.pointerId !== this.activePointerId) {
      return;
    }
    this.releasePointer(event2);
    this.revert();
  }
  onThumbKeydown(event2) {
    if (this.disabled || this.readOnly) {
      return;
    }
    const thumbElement = event2.target.closest("[data-thumb]");
    const thumb = this.parseThumb(thumbElement?.getAttribute("data-thumb") ?? null);
    if (!thumb) {
      return;
    }
    const values = this.committedValues();
    const current = thumb === "max" ? values[values.length - 1] : values[0];
    const next = valueFromSliderKey(this.numericRange, current, event2.key);
    if (next == null) {
      return;
    }
    event2.preventDefault();
    this.lastEmitted = values.join(",");
    this.moveThumb(thumb, next);
    this.commit();
  }
  static {
    _initClass();
  }
}
export { _RuiSlider as RuiSlider };